<template>
  <myhead @next="next" v-model:next="nextColor">
    <!-- {{ $route.query.title || $route.meta.title}} 11 -->
    <div @click="goodsType = !goodsType">{{ headertitle }}
      <img src="@/assets/img/icon65.png" v-if="goodsType" class="settingimg" />
      <img src="@/assets/img/icon66.png" class="settingimg" v-else />
    </div>
  </myhead>
  <div class="shopcontainer">
    <div class="shop-header-fixed" style="z-index:9">
      <div class="search-box">
        <Search :value="keyword" @click="handleSearch"></Search>
      </div>
      <div class="shopindex">
        <div class="flex center shopindex-bar size14">
          <div class="flex" @click="handleSel(1)">
            <p class="ml16" :class="{'active':condition == '1'}">销量</p>
            <img :src="
              condition == 1 && sort == 1
                ? require('@/assets/img/icon58.png')
                : condition == 1 && sort == 2
                ? require('@/assets/img/icon57.png')
                : require('@/assets/img/icon59.png')
            " class="height14px" />
          </div>
          <div class="flex" @click="handleSel(2)">
            <p class="ml16" :class="{'active':condition == '2'}">质量</p>
            <img :src="
              condition == 2 && sort == 1
                ? require('@/assets/img/icon58.png')
                : condition == 2 && sort == 2
                ? require('@/assets/img/icon57.png')
                : require('@/assets/img/icon59.png')
            " class="height14px" />
          </div>
          <div class="flex" @click="handleSel(3)">
            <p class="ml16" :class="{'active':condition == '3'}">物流</p>
            <img :src="
              condition == 3 && sort == 1
                ? require('@/assets/img/icon58.png')
                : condition == 3 && sort == 2
                ? require('@/assets/img/icon57.png')
                : require('@/assets/img/icon59.png')
            " class="height14px" />
          </div>
          <div class="flex" @click="handleSel(4)">
            <p class="ml16" :class="{'active':condition == '4'}">服务</p>
            <img :src="
              condition == 4 && sort == 1
                ? require('@/assets/img/icon58.png')
                : condition == 4 && sort == 2
                ? require('@/assets/img/icon57.png')
                : require('@/assets/img/icon59.png')
            " class="height14px" />
          </div>
          <div class="flex" @click="clickSetting">
            <p class="ml16" :class="{'active':showTop}">筛选</p>

            <img v-if="showTop" src="@/assets/img/icon78.png" class="settingimg" />
            <img v-else src="@/assets/img/icon66.png" class="settingimg" />
          </div>
        </div>
        <!-- 筛选弹窗 -->
        <van-popup v-model:show="showTop" position="top">
          <div class="popup-block">
            <p class="popup__tle a345 size14">发货地区</p>
            <div class="flex between center popup-area " v-for="(item, index) in addressList" :key="index">
              <input class="size14 a345" type="text" value="中国" disabled />
              <input @click="handleProvince(index)" class="size14 a345" type="text" v-model="item.province_value" />
              <input @click="handleCity(index)" class="size14 a345" type="text" v-model="item.city_value" />
              <!-- <select class="size14 a345" name="" id="" @change="handleProvince($event.target, index)">
                <option :value="item.id" v-for="item in areaitem.province" :key="item.id">
                  {{ item.title }}
                </option>
              </select>
              <select class="size14 a345" name="" id="" @change="handleCity($event.target, index)">
                <option :value="item.id" v-for="item in areaitem.city" :key="item.id" :selected="item.selected">
                  {{ item.title }}
                </option>
              </select> -->
              <img src="@/assets/img/icon29.png" v-if="index == (addressList.length - 1)" class="popup-area-add" @click="handleAddCity" />
              <img src="@/assets/img/icon28.png" v-else class="popup-area-del" @click="handleDeleteCity(index)" />

            </div>
            <div class="popup-volume-block">
              <p class="a345 size14">销量排名</p>
              <div class="popup-volume flex between center size14 a345">
                <p :class="{ active: sales_type == 1 }" @click="handleSaleType(1)">
                  月
                </p>
                <p :class="{ active: sales_type == 2 }" @click="handleSaleType(2)">
                  季
                </p>
                <p :class="{ active: sales_type == 3 }" @click="handleSaleType(3)">
                  年
                </p>
                <p :class="{ active: sales_type == 4 }" @click="handleSaleType(4)">
                  总
                </p>
                <div class="flex center">
                  前<input type="number" v-model="sales_num" />名
                </div>
              </div>
            </div>
            <div class="popup-price-block">
              <p class="a345 size14">价格区间</p>
              <div class="popup-price flex between center a345 size14">
                <input type="number" placeholder="最低价" v-model="min_price" @input="handlePriceChnage" />
                <div class="popup-price-bar"></div>
                <input type="number" placeholder="最高价" v-model="max_price" @input="handlePriceChnage" />
              </div>
            </div>
            <div class="popup-btn flex between center a345 size14">
              <button @click="handleReset">重置</button>
              <button @click="handleConfirm">确定</button>
            </div>
          </div>
        </van-popup>
      </div>
      <div v-if="sales_method == 3"   @click="openAuctionPopup">
        <Notices></Notices>
      </div>
    </div>
    <van-pull-refresh
      v-model="isLoading"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
    <div class="shoplist" :style="{'padding-top':(sales_method == 3?'140px':'100px')}">
          <div class="shopbox">
            <van-empty v-if="goosList.length == 0" description="数据为空" />
            <van-list v-model:loading="loading" :finished="finished" @load="onLoad">
              <div class="shoplist-li-box">
                <div class="shoplist-li" v-for="(item, index) in goosList" :key="index">
                  <div class="relative">
                    <div class="absolute l t size16  pad2" :class="item.sales_method == 1 ? 'BGshop1' : item.sales_method == 2 ? 'BGshop2' : 'BGshop3' ">{{ item.sales_name }}</div>
                    <img :src="item.original_img" :onerror="imgError" class="shoplist-li__shopimg" @click="
                      $router.push({
                        path: '/shop/detail',
                        query: { goods_id: item.goods_id },
                      })
                    " />
                  </div>
                  
                  <p class="shoplist-li__tle weight padx10">
                    {{ item.goods_name }} 
                  </p>
                  <div class="flex between padx10">
                    <p class="shoplist-li-money" v-if="item.sales_method == 1">
                      <span>¥</span>{{ item.shop_price }}
                    </p>
                    <p class="shoplist-li-money" v-if="item.sales_method == 2" @click="handleZX(item)">报价咨询</p>
                    <p class="size14 shoplist-li-price" v-if="item.sales_method == 3" >  <span class="Cred size16">￥{{  item.auction_price }} </span>  </p>
                    <img  v-if="item.sales_method == 1" src="@/assets/img/car.png" class="shoplist-li__carimg" @click="handleJg(item.goods_id)" />
                    <img  v-if="item.sales_method == 2 || item.sales_method == 3" :src="item.is_collect === 0 ? require('@/assets/img/collect.png'):require('@/assets/img/collect1.png')" @click="handleCollect(item)" class="shoplist-li__carimg"/>
                  </div>
                  <p class="padx10 mt5 size14 flex center" v-if="item.sales_method == 3" >距结束：
                    <van-count-down :format="item.auction_time>60*60*24*7?'DD 天':'HH : mm : ss'" :time="item.auction_time * 1000" class="C999" />

                  </p>
                </div>
              </div>
              <template #finished>{{ finishtxt }}</template>
            </van-list>
          </div>
          
        </div>
    </van-pull-refresh>
  </div>
  <WsTabbar></WsTabbar>
  <van-popup v-model:show="showBottom" position="bottom">
    <div class="popup">
      <Jiesuan v-model:goodsInfo="goodsInfo" handleSj="jg" @closeJs="closeJs"></Jiesuan>
    </div>
  </van-popup>
  <div class="goods_type">
    <van-popup v-model:show="goodsType" position="top">
      <div class="goods_type_box">
        <div class="goods_type_item" @click="tabGoodsType(item)" v-for="item,index in goodsTypeList" :key="index">
          <div class="goods_type_title">{{ item.label }}</div>

        </div>
      </div>
    </van-popup>
  </div>

  <!-- 拍卖获得者弹窗 -->

  <van-popup v-model:show="auctionPopup" position="bottom">
    <div class="popup">
      <AuctionList @closeJs="auctionPopup = false"></AuctionList>
    </div>
  </van-popup>
  <!-- 地址选择 -->
  <van-popup v-model:show="areaValue" position="bottom">
    <van-area @cancel="areaValue = false" @confirm="areaConfirm" title="地址选择" :columns-placeholder="['全部', '全部']" :area-list="areaList" value="310000"
      :columns-num="2" />
  </van-popup>

</template>

<script>
import { formatNumber } from "@/utils/util";
import Search from "@/components/Search.vue";
import Notices from './notices.vue'
import AuctionList from './auctionList.vue'
import Jiesuan from "./detail/jiesuan.vue";
import ajax from "@/utils/request.js";
import { showToast ,showConfirmDialog} from "vant";
import { areaList } from '@vant/area-data'
export default {
  name: "Shop",
  components: { Search, Jiesuan,Notices,AuctionList },
  data () {
    return {
      auctionPopup:false,// 拍卖获得者弹窗状态
      isLoading:false,//下拉状态
      areaValue: false,
      downImg: require('@/assets/img/icon66.png'),
      active: 0,
      loading: false, //加载的时候设置为true，不会去执行加载函数
      finished: false, //后台没数据后，加载完毕设置为true
      goosList: [],
      goodsInfo: {},
      areaList,
      addressList: [],
      addressIndex: 0,
      page: 1,
      currentcondition: 0, //保存之前的condition
      condition: 0, //条件 1：销量 2：质量 3：物流 4：服务
      sort: 0, //排序 1:降序 2：升序 0：默认
      showTop: false,
      areacon: [], //保存地区信息
      area: [], //地区
      regiontwo: [], //省
      addressJson: [], //上传地址json
      min_price: "",
      max_price: "",
      sales_type: "", //销量类型
      sales_num: "", //前几名
      showBottom: false,
      keyword: "",
      finishtxt: "",
      nextColor: false,
      timer: null,
      cacheScroll: 0,
      headertitle: '定价商品',
      goodsType: false,// 商品类型选择弹窗
      sales_method:1,// 销售方式
      goodsTypeList: [
        { type: 0, label: '全部' },
        { type: 1, label: '定价商品' },
        { type: 2, label: '定制商品' },
        { type: 3, label: '拍卖商品' },
      ]
    };
  },
  watch: {},
  methods: {
    // 打开弹窗
    openAuctionPopup(){
      this.auctionPopup = true
    },
    // 刷新
    onRefresh(){
      this.page = 1
      this.goosList = []
      this.sort = 0
      this.condition = 0
      this.finished = false
      this.keyword = ' '
      this.getGoodsList()
      this.isLoading = false
    },
    // dsq add 咨询
    handleZX(item){
      if (!localStorage.getItem('loginInfo')) {
        showConfirmDialog({
          title: '是否登录'
        })
          .then(() => {
            // on confirm
            this.$router.push({ path: "/login" })
          }).catch(() => {
            return false
          });

      } else {
        this.$router.push({ path: '/shop/feedback', query: { title: '咨询定制商品', goods_id: item.goods_id, type: 2 } })
      }
    },
    //dsq add  设置收藏
    handleCollect(item){
      const collect = item.is_collect === 0 ? 1 : 2
      const data = {
        typeid:collect,
        id:item.goods_id
      }
      ajax.post("products/collect", data).then(res => {
        if (res.errcode === 1) {
          showToast(res.message)
          this.goosList = []
          this.getGoodsList()
        }
      })
    },
    // 地址选项确认
    areaConfirm (val) {
      this.addressList[this.addressIndex].province_value = val.selectedOptions[0].text
      this.addressList[this.addressIndex].city_value = val.selectedOptions[1].text
      if (val.selectedOptions[0].text !== '全部') {
        let province_item = this.area[0].province.find(item => item.code == val.selectedValues[0])
        this.addressJson[this.addressIndex].province_id = province_item.id
        if (val.selectedOptions[1].text !== '全部') {
          let city_item = province_item.regiontwo.find(item => item.code == val.selectedValues[1])
          this.addressJson[this.addressIndex].city_id = city_item.id
        } else {
          this.addressJson[this.addressIndex].city_id = ''
        }
      } else {
        this.addressJson[this.addressIndex].province_id = ''

      }
      this.areaValue = false
    },
    // 点击筛选按钮
    async clickSetting () {
      if (this.showTop === false && this.area.length === 0) {
        await ajax.post("api/getregionlist").then((res) => {
          const list = res.data.list;
          list.forEach((item) => {
            item.regiontwo = [
              { code: "", id: "", level: 2, parent_id: item.id, title: "全部" },
              ...item.regiontwo,
            ];
          });
          list.unshift({
            code: "",
            id: "",
            level: 1,
            parent_id: 0,
            regiontwo: [
              {
                code: "",
                id: "",
                level: 2,
                parent_id: 32,
                title: "全部",
              },
            ],
            title: "全部",
          });
          this.areacon = list;
          this.area.push({
            province: list,
            city: list[0].regiontwo,
          });
          //初始化添加地址json
          this.addressJson.push({
            province_id: list[0].id,
            city_id: list[0].regiontwo[0].id,
          });
          this.addressList.push({
            province_value: '全部',
            city_value: '全部'
          })
          // this.area[0].city[0].selected = true;
        });
        this.showTop = !this.showTop;
      } else {
        this.showTop = !this.showTop;
      }
    },
    // 选择省
    handleProvince (index) {
      this.areaValue = true
      this.addressIndex = index
      // const cityId = e.value;
      // const obj = this.area[index].province.find((item) => {
      //   return item.id == cityId;
      // });
      // this.area[index].city = obj.regiontwo;
      // this.area[index].city[0].selected = true;
      // //修改地址json的province_id
      // this.addressJson[index].province_id = cityId;
      // this.addressJson[index].city_id = ""; //切换时城市为全部为空
    },
    // 选择市
    handleCity (index) {
      this.areaValue = true
      this.addressIndex = index
      // this.addressJson[index].city_id = e.value;
    },
    // 添加地址选择
    handleAddCity () {
      // this.area.push({
      //   province: this.areacon,
      //   city: this.areacon[0].regiontwo,
      // });
      this.addressJson.push({
        province_id: this.areacon[0].id,
        city_id: this.areacon[0].regiontwo[0].id,
      });
      this.addressList.push({
        province_value: '全部',
        city_value: '全部'
      })
    },
    // 删除地址选择
    handleDeleteCity (index) {
      //删除地址json的index位置
      this.addressJson.splice(index, 1);
      this.addressList.splice(index, 1);
    },
    //设置确定
    handleConfirm () {
      this.page = 1;
      let data = {
        page: this.page,
        keyword: this.keyword,
      };
      if (this.addressJson.length > 0) {
        data = { address: JSON.stringify(this.addressJson), ...data };

      }
      if (this.sort !== 0) {
        if (this.sort == 1) {
          data = { field: this.condition, sort: 2, ...data };
        } else {
          data = { field: this.condition, sort: 1, ...data };
        }
      }
      if (this.min_price != "" && Number(this.min_price) !== "NaN") {
        data = { min_price: this.min_price, ...data };
      }
      if (this.max_price != "" && Number(this.max_price) !== "NaN") {
        data = { max_price: this.max_price, ...data };
      }
      if (this.sales_type !== "" && this.sales_num !== "") {
        data = {
          sales_type: this.sales_type,
          sales_num: this.sales_num,
          ...data,
        };
      }
       // 添加销售方式
       data = {
        sales_method:this.sales_method,
        ...data
      }

      ajax.post("products/getlist", data).then((res) => {
        this.goosList = [];
        this.goosList = res.data;
        this.showTop = false;
      });
    },
    // 点击重置
    handleReset () {
      this.min_price = "";
      this.max_price = "";
      this.sales_type = "";
      this.sales_num = "";
      this.area = [];
      this.addressList = [];
      this.addressJson = [];

          this.addressList.push({
            province_value: '全部',
            city_value: '全部'
          })
    },
    // 切换销售方式
    tabGoodsType (item) {
      this.headertitle = item.label
      this.goodsType = false
      this.page = 1
      this.finished = false
      this.goosList = []

      this.sales_method = item.type
      this.getGoodsList()


    },
    // 头部组件下一步
    next () {
      // this.active = (this.active + 1) % 5;
      history.forward();
    },
    handleSearch () {
      this.$router.push({
        path: "/shop/search",
        // query: { origin: window.location.pathname, ...this.$route.query, },
        // dsq add 
        query: { type: 'index' }
      });
    },
    // 获取当前数据
    async getGoodsList () {
      //如果销量质量进行切换，清空之前的数组
      if (this.condition !== this.currentcondition) {
        this.goosList = []
        this.currentcondition = this.condition
      }

      //执行加载事件
      this.loading = true;
      let data = {
        page: this.page,
        keyword: this.keyword,
      };
      if (this.addressJson.length > 0) {
        data = { address: this.addressJson, ...data };
      }
      if (this.sort !== 0) {
        let sortVal = 1
        if (this.sort == 1) {
          sortVal = 2
        }
        data = { field: this.condition, sort: sortVal, ...data };
      }
      if (this.min_price != "" && Number(this.min_price) !== "NaN") {
        data = { min_price: this.min_price, ...data };
      }
      if (this.max_price != "" && Number(this.max_price) !== "NaN") {
        data = { max_price: this.max_price, ...data };
      }
      if (this.sales_type !== "" && this.sales_num !== "") {
        data = {
          sales_type: this.sales_type,
          sales_num: this.sales_num,
          ...data,
        };
      }
      // 添加销售方式
      data = {
        sales_method:this.sales_method,
        ...data
      }
      ajax
        .post("products/getlist", data)
        .then((res) => {

          const formatData = res.data.map(item => {  
            // 检查是否存在 auction_price 属性  
            if (item.auction_price) {  
              // 转换 auction_price  
              item.auction_price = formatNumber(item.auction_price);  
            }  
            // 返回转换后的项  
            return item;  
          });  
          if (formatData.length < 10) {
            this.finishtxt = "";
            this.finished = true;
            this.goosList = this.goosList.concat(res.data);
            setTimeout(() => {
              this.finishtxt = "没有更多了";
            }, 1000);
          } else {
            this.finishtxt = "";
            this.goosList = this.goosList.concat(res.data);
            
            this.page++;
          }

          
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(() => {
          this.finished = true;
        });
    },
    handleSel (val) {
      this.page = 1;
      // 未切换筛选类型
      if (this.condition == val) {
        this.sort = this.sort == 0 ? 1 : this.sort == 1 ? 2 : 0;
      } else {
        this.sort = 1
      }
      this.finished = false
      this.condition = val;
      this.goosList = [];
      this.getGoodsList();
    },
    handleSaleType (val) {
      this.sales_type = val;
    },

    //点击购物车图标加购
    async handleJg (id) {
      const data = {
        goods_id: id,
      };
      await ajax.post("products/getinfo", data).then((res) => {
        this.goodsInfo = { ...res.data };
        this.isLogin(this.$route.fullPath, () => {
          if (this.goodsInfo.is_concept == 0) {
            // showToast({
            //   message: "观念不匹配",
            // });
            this.$router.push({ path: "/shop/sense", query: { cate_id: 0 } });
            return;
          }
          this.goodsInfo.spec.forEach((item) => {
            (item.sum = 0), (item.isActive = false); //0 否   1 是
          });
          this.showBottom = true;
        })


      });
    },
    onLoad () {
      this.getGoodsList();
    },
    handlePriceChnage () {
      if (this.min_price < 0) {
        this.min_price = +0;
      }
      if (this.max_price < 0) {
        this.max_price = +0;
      }
    },
    closeJs () {
      this.showBottom = false;
    },
  },
  mounted () {
    document.getElementById('containerScroll').addEventListener('scroll', () => {

      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        const scrollTop = document.getElementById('containerScroll').scrollTop
        this.cacheScroll = scrollTop
      }, 500)
    })
  },
  activated () {
    const shopIndexScroll = sessionStorage.getItem('shopindex')
    if (shopIndexScroll) {
      setTimeout(() => {
        document.getElementById('containerScroll').scrollTop = shopIndexScroll
      }, 500)
    }
    if (history.state.forward) {
      this.nextColor = true;
    }

    // 路径变化，恢复默认
    if (this.$route.query.search && this.$route.query.search !== this.keyword) {
      this.goosList = []
      this.page = 1
      this.keyword = this.$route.query.search
      this.getGoodsList()
    }
    // if (!this.$route.query.search) {
    //   this.page = 1
    //   this.goosList = []
    //   this.sort = 0
    //   this.condition = 0
    //   this.finished = false
    //   this.keyword = ' '
    //   this.getGoodsList()

    // }
  },
  deactivated () {
    sessionStorage.setItem('shopindex', this.cacheScroll)
  }
};
</script>

<style scoped lang="scss">
.settingimg {
  width: 14px;
  margin-left: 1.0667vw;
}
// 头部商品类型选择弹窗
.goods_type{
 ::v-deep .van-popup--top {
    top: 50px;
  }
  ::v-deep .van-overlay{
    top:50px;
  }
}
.goods_type_box{
  .goods_type_item{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 20px;
    padding: 10px 0;
    border-bottom: 1px solid #e8e8e8;
    font-size: 16px;
    .goods_type_title{
      text-align:center;
      font-size: 20px;
    }
    .goods_type_icon{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 18px;
      height: 18px;
      margin-left:15px;
      img{
        width: 80%;
        height:80%;
      }
    }
  }
}
.shop-header-fixed{
  position: fixed;
  width: 100%;
  padding-bottom: 10px;
  background-color: #fff;
}
.popup-area-del {
  width: 4.2667vw;
  height: 4.2667vw;
}
.popup-area-add {
  width: 4.2667vw;
  height: 4.2667vw;
}


.search-box {
  padding: 6px 4vw;
}
.shopindex-bar {
  justify-content: space-around;
  padding-right: 4vw;
}
.shopindex {
  .popup-block {
    padding: 4vw;
    select{
      appearance: none;
      // background-size: 14px;
    }
  }
  .popup-area {
    margin-top: 2.6667vw;
    margin-bottom: 2.6667vw;
    input,
    select {
      width: 26.6667vw;
      height: 9.6vw;
      background-color: #f6f6f6;
      border-radius: 4.8vw;
      text-align: center;
    }
  }
  .popup-volume-block {
    margin-top: 5.3333vw;
    .popup-volume {
      margin-top: 2.6667vw;
      p {
        width: 12.8vw;
        height: 9.6vw;
        line-height: 9.6vw;
        text-align: center;
        background-color: #f6f6f6;
        font-size: 14px;
        border-radius: 4.8vw;
      }
      p.active {
        border: 1px solid #3f7c93;
        color: #3f7c93;
      }
      input {
        width: 18.1333vw;
        height: 9.6vw;
        background: #f6f6f6;
        border-radius: 4.8vw;
        text-align: center;
        margin-left: 1.0667vw;
        margin-right: 1.0667vw;
      }
    }
  }
  .popup-price-block {
    margin-top: 5.3333vw;
    .popup-price {
      margin-top: 2.6667vw;
      .popup-price-bar {
        width: 3.7333vw;
        height: 1px;
        background: #d8d8d8;
      }
      input {
        width: 43.2vw;
        height: 9.6vw;
        line-height: 9.6vw;
        text-align: center;
        background: #f6f6f6;
        border-radius: 4.8vw;
      }
    }
  }
  .popup-btn {
    margin-top: 12.8vw;
    button {
      width: 44vw;
      height: 10.6667vw;
      line-height: 10.6667vw;
      text-align: center;
      border-radius: 5.8667vw;
      border: 1px solid #3f7c93;
      box-sizing: border-box;
      background: #ffffff;
      font-size: 14px;
      color: #3f7c93;
      &:last-child {
        border: 0;
        color: #ffffff;
        background: #3f7c93;
      }
    }
  }
}

.shoplist {
  padding: 100px 4vw 60px;
  
  .shoplist-li-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .shoplist-li {
    width: 43.7333vw;
    background-color: #fff;
    padding-bottom: 2.1333vw;
    box-sizing: border-box;
    margin-top: 2.6667vw;
    .shoplist-li__shopimg {
      display: block;
      // width: 39.4667vw;
      width: 100%;
      height: 39.4667vw;
      object-fit:cover;
      background-color: #f6f6f6;
      border-radius: 6px;
    }
    .shoplist-li__tle {
      color: #333333;
      font-size: 16px;
      // height: 56px;
      margin-top: 2.6667vw;
      margin-bottom: 3.2vw;
      word-break: break-all;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    }
    .shoplist-li-money {
      color: #ff0000;
      font-size: 16px;
      span {
        font-size: 12px;
        margin-right: 2px;
      }
    }
    .shoplist-li-price{
      width: 80%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .shoplist-li__carimg {
      width: 5.8667vw;
    }
  }
}
.shoplist .van-list__loading {
  width: 100%;
}
.popup {
  padding: 6.4vw 4vw 17.0667vw;
}
.active{
  color: #3F7C93;
}

// .auction-popup-box{
//   position: relative;
// }
// .auction-popup-header{
//   position: fixed;
//   top: 0;
//   height: 8%;
// }
// .auction-popup-content{
//   height: 92%;
// }

</style>

